<div class="page">
  <nav class="breadcrumb" [attr.aria-label]="'COMMON.BREADCRUMB' | translate">
    <a [routerLink]="busesLink" class="breadcrumb-link">{{ 'BUSES.TITLE' | translate }}</a>
    <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
    <span class="breadcrumb-current">{{ bus?.name || bus?.number || ('BUSES.DETAILS' | translate) }}</span>
  </nav>

  <div class="page-header">
    <div>
      <h1>{{ bus?.name || ('BUSES.DETAILS' | translate) }}</h1>
      <p class="page-subtitle" *ngIf="bus">
        {{ bus.number }}
        <span *ngIf="students.length"> · {{ students.length }} {{ 'BUSES.STUDENTS' | translate }}</span>
      </p>
    </div>
    <div class="page-actions">
      <button type="button" class="btn btn-secondary" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        {{ 'COMMON.BACK' | translate }}
      </button>
    </div>
  </div>

  <div class="alert alert-error" *ngIf="errorMessage">{{ errorMessage | translate }}</div>

  <div class="card" *ngIf="loading">
    <div class="empty-state">{{ 'COMMON.LOADING' | translate }}</div>
  </div>

  <div class="bus-profile" *ngIf="!loading && bus">
    <section class="card info-card">
      <header class="section-header">
        <h3>{{ 'BUSES.OVERVIEW' | translate }}</h3>
      </header>
      <div class="info-body">
        <div class="info-grid">
          <div class="info-row">
            <span class="info-label">{{ 'COMMON.NAME' | translate }}</span>
            <span class="info-value">{{ valueOrDash(bus.name) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'BUSES.NUMBER' | translate }}</span>
            <span class="info-value">{{ valueOrDash(bus.number) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'BUSES.PLATE' | translate }}</span>
            <span class="info-value">{{ valueOrDash(bus.plateNumber) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'BUSES.CAPACITY' | translate }}</span>
            <span class="info-value">{{ valueOrDash(bus.capacity) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'BUSES.DRIVER' | translate }}</span>
            <span class="info-value">{{ valueOrDash(bus.driverName) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'BUSES.DRIVER_PHONE' | translate }}</span>
            <span class="info-value">
              <a *ngIf="bus.driverPhone; else noPhone" class="phone-link" [href]="'tel:' + bus.driverPhone">
                {{ bus.driverPhone }}
              </a>
              <ng-template #noPhone>—</ng-template>
            </span>
          </div>
        </div>
        <aside class="bus-qr" *ngIf="qrDataUrl">
          <img [src]="qrDataUrl" [alt]="'BUSES.QR_CODE' | translate" />
        </aside>
      </div>
    </section>

    <section class="card students-card">
      <header class="section-header">
        <h3>{{ 'BUSES.STUDENTS' | translate }}</h3>
        <span class="section-count" *ngIf="students.length">{{ students.length }}</span>
      </header>

      <div class="table-scroll" *ngIf="students.length; else noStudents">
        <table class="data-table">
          <thead>
            <tr>
              <th>{{ 'STUDENTS.NAME' | translate }}</th>
              <th>{{ 'STUDENTS.CODE' | translate }}</th>
              <th>{{ 'STUDENTS.CLASS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let student of students"
              [class.clickable]="permissions.canView('students')"
              (click)="openStudent(student)"
            >
              <td>{{ studentName(student) }}</td>
              <td>{{ valueOrDash(student.studentCode) }}</td>
              <td>{{ valueOrDash(student.class?.name) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noStudents>
        <p class="empty-state">{{ 'BUSES.NO_STUDENTS' | translate }}</p>
      </ng-template>
    </section>
  </div>
</div>
